import request, { download } from "@/utils/request";
import { ElMessage, ElLoading } from "element-plus";
import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";
import errorCode from '@/utils/errorCode'

//管理区域日课消排名列表
export function getManageAreaDailyRank (params) {
  return request({
    url: "/report/consumption/daily/rank/manageArea/list",
    method: "get",
    headers: { repeatSubmit: false },
    params: params,
  });
}

//教学区域日课消排名列表
export function getTeachingAreaDailyRank (params) {
  return request({
    url: "/report/consumption/daily/rank/teachingArea/list",
    method: "get",
    headers: { repeatSubmit: false },
    params: params
  });
}

//全国校区日课消排名
export function getCampusDailyRank (params) {
  return request({
    url: "/report/consumption/daily/rank/school/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: params,
  });
}

//管理区域列表
export function getAreaInfo () {
  return request({
    url: "/system/classConsumeConfig/getAreaInfo",
    method: "get",
    headers: { repeatSubmit: false },
  });
}

//获取区域下校区
export function getSchoolList (params) {
  return request({
    url: "/system/classConsumeConfig/getSchool",
    method: "get",
    headers: { repeatSubmit: false },
    params: params,
  });
}

//获取管理区域课消明细
export function getManageAreaDetailList (query) {
  return request({
    url: "/report/school/mangementSchoolsStudentAtteandance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//获取管理区域课消明细合计数据
export function getManageAreaDetailSummary (query) {
  return request({
    url: "/system/classConsumeConfig/getTotalAreaDetailList",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//获取管理区域校区课消明细
export function getManageAreaCampusDetailList (query) {
  return request({
    url: "/report/class/consumption/getAreaDetailOnTeacherList",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//获取管理区域校区统计数据
export function getTotalSchoolDetail (query) {
  return request({
    url: "/report/class/consumption/getTotalSchoolDetail",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//学员服务老师课消明细
export function getServeTeacherDetailList (query, pageInfo) {
  return request({
    url: "/system/classConsumeConfig/getTeacherConsumeDetail",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}
//学员服务老师课消明细汇总
export function getStudentServiceConsumeTotal (query) {
  return request({
    url: "/system/classConsumeConfig/getStudentServiceConsumeTotal",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//教学区域列表
export function getTeachingAreaInfo () {
  return request({
    url: "/system/crm/report/teachering/region",
    method: "get",
    headers: { repeatSubmit: false },
  });
}

//获取教学区域校区
export function getTeachingSchoolList (params) {
  return request({
    url: "/system/crm/report/teachering/region/campus",
    method: "get",
    headers: { repeatSubmit: false },
    params: params,
  });
}

//获取教学区域课消明细列表
export function getTeachingAreaDetailList (query) {
  return request({
    url: "/report/school/educationSchoolsStudentAtteandance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//获取教学区域学员课消明细
export function getTeachingStudentConsumeDetailList (query, pageInfo) {
  return request({
    url: "/report/class/consumption/getStudentsConsumeDetail",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}

//获取教学区域学员课消明细汇总
export function getTeachingStudentConsumeTotal (query) {
  return request({
    url: "/report/class/consumption/getStudentsConsumeTotal",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//教学区域校区课消明细
export function getTeachingCampusList (query, pageInfo) {
  return request({
    url: "/system/crm/report/teachering/region/campus/report",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}
//教学区域班级课消明细
export function getTeachingClassList (query, pageInfo) {
  return request({
    url: "/report/class/consumption/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}

//授课老师课消明细
export function getTeacherkxDetailList (query, pageInfo) {
  return request({
    url: "/report/class/consumption/detail/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}

//校区课消明细
export function getCampusDetailList (query) {
  return request({
    url: "/report/school/stduentAttendance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//获取校区课消明细统计计数据
export function getTotalCampusDetailInfo (query) {
  return request({
    url: "/system/classConsumeConfig/getTotalAreaDetailList",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//学员消耗金额明细
export function getStudentConsumeDetail (query, pageInfo) {
  return request({
    url: "/report/class/consumption/getStudentConsumeDetail",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}

//学员消耗金额明细, A/B版课消
export function getStudentConsumeDetailNew (query, pageInfo) {
  return request({
    url: "/report/class/consumption/getStudentConsumeDetailNew",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo,
  });
}

//学员消耗金额明细统计
export function getStudentConsumeTotal (query) {
  return request({
    url: "/report/class/consumption/getStudentConsumeTotal",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}

//导出excel
export async function exportExcel (url, params, filename, method = "post") {
  let downloadLoadingInstance = ElLoading.service({
    text: "正在下载数据，请稍候",
    background: "rgba(0, 0, 0, 0.7)",
  });
  if (!filename || typeof filename != "string") {
    filename = "导出文件";
  }
  try {
    let data = null;
    if (method === 'post') {
      data = await request({
        url: url,
        method: "post",
        responseType: "blob",
        data: params,
      });
    } else if (method === 'get') {
      data = await request({
        url: url,
        method: "get",
        responseType: 'blob',
        params: params,
      })
    }
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data]);
      saveAs(blob, filename);
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg =
        errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
      ElMessage.error(errMsg);
    }
    downloadLoadingInstance.close();
  } catch (error) {
    console.log(error, 111);
    ElMessage.error("下载文件出现错误，请联系管理员！");
    downloadLoadingInstance.close();
  }
}

//科目课消汇总
export function getSubjectKxhz (query) {
  return request({
    url: "/report/subject/performance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//导出科目课消汇总
export function exportSubjectKxhz (query) {
  return download(
    `/report/subject/performance/export`,
    { ...query },
    `科目课消汇总_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}
//产品课消汇总
export function getProductKxhz (query) {
  return request({
    url: "/report/product/performance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//导出产品课消汇总
export function exportProductKxhz (query) {
  return download(
    `/report/product/performance/export`,
    { ...query },
    `产品课消汇总_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}
//项目课消明细
export function getProjectKxhz (query) {
  return request({
    url: "/report/project/performance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//导出项目课消明细
export function exportProjectKxhz (query) {
  return download(
    `/report/project/performance/export`,
    { ...query },
    `项目课消汇总_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}

//获取未课消风险提示分页查询列表
export function getNonkxRiskList (query, pageInfo) {
  return request({
    url: '/report/course/risk/page',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo
  })
}
//学员课消明细
export function getStudentKxhz (query) {
  return request({
    url: "/report/student/performance/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//导出学员课消明细
export function exportStudentKxhz (query) {
  return download(
    `/report/student/performance/export`,
    { ...query },
    `学员课消明细_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}
//科目报名人数明细
export function getSubjectAccount (query) {
  return request({
    url: "/report/subject/account/list",
    method: "post",
    headers: { repeatSubmit: false },
    data: query,
  });
}
//导出学员课消明细
export function exportSubjectAccount (query) {
  return download(
    `/report/subject/account/export`,
    { ...query },
    `科目报名人数明细_${new Date().getTime()}.xlsx`,
    { headers: { 'Content-Type': 'application/json' }, }
  );
}


/**学员课消明细 */
//获取学员课消明细列表
export function getStudentKxList (query, pageInfo) {
  return request({
    url: '/report/class/consumption/getAreaDetailOnStudentList',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo
  })
}

//获取学员课消明细汇总
export function getTotalStudentKxInfo (query) {
  return request({
    url: '/report/class/consumption/getTotalStudentSchoolDetail ',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query
  })
}

//获取授课老师课时统计列表
export function getTeacherClassHourCountList (query, pageInfo) {
  return request({
    url: '/report/teacher/course/time/list',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
    params: pageInfo
  })

}

//获取计划班学院轨迹列表
export function getPlanedClassStudentTrackList (query) {
  return request({
    url: '/report/plan/student/route/list',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
  })
}


// 查询管理区域树
export function getManageAreaTree () {
  return request({
    url: "/system/region/tree",
    method: "get",
  });
}

//查询教学区域树
export function getTeachAreaTree () {
  return request({
    url: '/system/region/teaching/tree',
    method: 'get'
  })
}

//查询所有管理区域校区
export function getManageAreaAllTree () {
  return request({
    url: "/system/region/allTree",
    method: "get",
  });
}

//查询所有非关停校区
export function getNotShutdownTree () {
  return request({
    url: "/system/region/treeNotShutdown",
    method: "get",
  });
}

//查询所有校区
export function getRegionTreeAll() {
  return request({
    url: "/system/region/treeAll",
    method: "get",
  });
}

// 查询计划内校区(用于高管首页)
export function getHomePlanTree () {
  return request({
    url: "/system/region/treePlan",
    method: "get",
  });
}

// 查询所有非关停校区(教材专用)
export function getRegionOpenTree () {
  return request({
    url: "/system/region/open/tree",
    method: "get",
  });
}

// 有权限管理区域加待分配校区
export function getManageAreaTreePlus () {
  return request({
    url: "/system/region/treePlus",
    method: "get",
  });
}